// HearFromOurTeam.js
// "use client"; // Uncomment if using Next.js App Router

import React from "react";
import { Quote } from "lucide-react";
import Carrers_Image1 from "../../assets/new-images/Careersb1.jpeg";
import Carrers_Image2 from "../../assets/new-images/Careersb2.jpeg";
import Carrers_Image3 from "../../assets/new-images/Careersb3.jpeg";
import Carrers_Image4 from "../../assets/new-images/Careersb4.png";
import Image_zaki from "../../assets/new-images/Zaki.png";

const testimonials = [
  {
    quote:
      "Simplifyte gave me the freedom to do my best work while surrounded by the most talented people I've ever worked with.",
    name: "Zaki Asil",
    role: "Senior Frontend Developer",
    avatar: Image_zaki,
    // "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop", // replace with your path
  },
  {
    quote:
      "The culture here is genuinely different. We ship fast, learn constantly, and support each other through everything.",
    name: "Manav Rathod",
    role: "Backend Developer",
    avatar: "https://ziaat.com/teams/manav-rathod.png",
    //     "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  },
  {
    quote:
      "I've grown more in one year here than I did in three years at my previous company. The investment in people is real.",
    name: "Danish Loya",
    role: "Frontend Developer",
    avatar: "https://ziaat.com/teams/danish.png",
    // "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop",
  },
];

const gallery = [
  //   "https://images.unsplash.com/photo-1758691736975-9f7f643d178e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwdGVhbXxlbnwxfHx8fDE3NjM3NTg2Nzd8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
  //   "https://images.unsplash.com/photo-1693159682660-c125e71844d8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZSUyMGRlc2t8ZW58MXx8fHwxNzYzNjQ0MTExfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
  //   "https://images.unsplash.com/photo-1611736362199-2f7e76ebeca4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGFyY2hpdGVjdHVyZXxlbnwxfHx8fDE3NjM3MzY2NTF8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
  //   "https://images.unsplash.com/photo-1630283017802-785b7aff9aac?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3BhY2V8ZW58MXx8fHwxNzYzNzI2OTQxfDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral",
  Carrers_Image1,
  Carrers_Image2,
  Carrers_Image3,
  Carrers_Image4,
];

export default function HearFromOurTeam() {
  return (
    <section className="w-full bg-gradient-to-tl from-[#0A3A6B]/80  to-[#0064D6]/80 pt-28 pb-28 px-4 lg:px-16 text-white -mb-24">
      <div className="max-w-6xl mx-auto text-center">
        {/* Tag */}
        <span className="carrers_team-class">Hear From Our Team</span>

        {/* Heading */}
        <h2 className="carrers_team-heading">Voices from Simplifyte</h2>

        {/* Sub-heading */}
        <p className="carrers_team-para">
          Don’t just take our word for it. Here’s what our team members have to
          say about working here.
        </p>
      </div>

      {/* Testimonials */}
      <div className="mt-16 grid gap-8 md:grid-cols-3 max-w-6xl mx-auto">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className=" flex flex-col justify-between gap-6 rounded-3xl border border-white/20 bg-[#FFFFFF1A] backdrop-blur-sm p-8  hover:bg-white/15 duration-300"
          >
            {/* Quote icon */}
            <div>
              <Quote className="text-white/60 " size={32} />
            </div>

            {/* Quote text */}
            <div>
              <p className="carrers_quote">{item.quote}</p>
            </div>

            {/* Avatar + details */}
            <div className=" flex items-center gap-3">
              <img
                src={item.avatar}
                alt={item.name}
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <p className="font-semibold text-white">{item.name}</p>
                <p className="text-white/70 text-xs">{item.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Gallery */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {gallery.map((img, i) => (
          <div
            key={i}
            className="rounded-2xl overflow-hidden shadow-lg shadow-black/20"
          >
            <img
              src={img}
              alt=""
              className="h-64 w-full object-cover transition-transform duration-300 ease-out hover:scale-105"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
